import type { IconSvgObject } from './types';

const BitcoinIcon: IconSvgObject = [
  ["path", { d: "M6 4H14.4C16.3882 4 18 5.79086 18 8C18 10.2091 16.3882 12 14.4 12M14.4 12C16.3882 12 18 13.7909 18 16C18 18.2091 16.3882 20 14.4 20H6M14.4 12H7.2", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 4V20", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M9 2L9 4M14 2V4", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M9 20L9 22M14 20V22", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "3" }]
];

export default BitcoinIcon;
